module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_crm-714a0fb5b568222818653b8ee3ae3805.jpg";